const VIDEOS_PATH = '/assets/videos';

export const stella = `${VIDEOS_PATH}/stella.mp4`;
